/** @format */

import React, { useEffect, useState } from "react";
import { Form, Select, Button, Divider, Space } from "antd";
import { useHistory } from "react-router";
import notifAlert from "../../../components/NotifAlert";
import { useDispatch, useSelector } from "react-redux";

import { getProfile } from "../../../services/v2/usermanservice/profileservices";
import { setStore } from "../../../redux/actions";
import { editMadrasah } from "../../../services/v2/usermanservice/madrasahservices";
import { getLevelPPK } from "../../../services/v2/referenceservice/levelppkservices";

const PPK = () => {
  const route = useHistory();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const store = useSelector((state: any) => state.store);
  const [levelPPK, setLevelPPK] = useState<any>([]);
  const madrasah = store?.profile?.madrasah || null;
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [madrasah]);

  const getData = async () => {
    try {
      const res = await getLevelPPK({
        activated: 1,
      });
      setLevelPPK(res || []);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSavePPK = async (values) => {
    setIsLoading(true);
    try {
      let payload = {
        id: madrasah.id,
        kode_level_ppk: values.ppk,
      };
      await editMadrasah(payload);
      notifAlert({ type: "success", description: "Data Berhasil di simpan" });
      setTimeout(async () => {
        const profile = await getProfile();
        const dataProfile = { profile };
        dispatch(setStore(dataProfile));
      }, 100);
    } catch (err) {
      console.log(err);
    }
    setIsLoading(false);
  };

  return (
    <>
      <div className="p-4">
        <Form
          form={form}
          key="formEditProfile"
          name="formEditProfile"
          layout="vertical"
          initialValues={{ ppk: madrasah?.kode_level_ppk }}
          onFinish={handleSavePPK}>
          <Form.Item
            label="PPK"
            name="ppk"
            rules={[{ required: true, message: "PPK tidak boleh kosong!" }]}>
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Pilih PPK">
              {levelPPK?.length &&
                levelPPK.map((e: any, i: any) => {
                  return (
                    <Select.Option key={`ppk${i}`} value={e.kode}>
                      {e.nama}
                    </Select.Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Divider />
          <Space className="">
            <Button
              onClick={() => {
                route.push("/profile-madrasah");
              }}>
              Batal
            </Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Simpan
            </Button>
          </Space>
        </Form>
      </div>
    </>
  );
};

export default PPK;
